import { Box, Typography } from '@mui/material';
import React, { FC, useCallback } from 'react';
import { useStyles } from './SidebarMenuLink.styles';
import { NavigationMenuItem } from 'app/interfaces/sidebar';

interface SidebarMenuLinkProps {
  item: NavigationMenuItem;
  onClick?: (item: NavigationMenuItem) => void;
}

export const SidebarMenuLink: FC<SidebarMenuLinkProps> = ({ item, onClick }) => {
  const { classes } = useStyles();

  const onClickHandler = useCallback(() => {
    onClick?.(item);
  }, [onClick, item]);

  if (!item) {
    return null;
  }

  return (
    <Box onClick={onClickHandler} className={classes.root}>
      <Typography className={classes.label}>{item.label}</Typography>
      {item.icon && <Box className={classes.icon}>{React.createElement(item.icon)}</Box>}
    </Box>
  );
};
